var map = {
	"./video_1.mp4": 1726,
	"./video_2.mp4": 4465,
	"./video_3.mp4": 8641,
	"./video_4.mp4": 1527,
	"./video_5.mp4": 8699,
	"./video_6.mp4": 1347,
	"./video_7.mp4": 7120,
	"./video_8.mp4": 6400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8267;